module.exports = __webpack_public_path__ + "img/xu.19080589.png";